module.exports = __webpack_public_path__ + "img/crosshair.10f8ff8d.svg";